import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const COLORS = ['#05DB8E', '#B3F000', '#D91D4A', '#680EE4'];

const FollowerTypes = ({ data }) => {
  const sortedData = data.sort((a, b) => b.value - a.value);
  const highestValue = sortedData[0];

  const chartData = sortedData.map(item => ({
    name:
      item.name === 'real'
        ? 'Real'
        : item.name === 'influencers'
        ? 'Influencers'
        : item.name === 'mass_followers'
        ? 'Mass Followers'
        : 'Suspicious',
    value: item.value,
  }));

  return (
    <Card className="followers-type-container border rounded-0">
      <Card.Body>
        <h6 className="sub-heading">Follower Types</h6>
        <Row className="align-items-center border audience-border-radius py-4">
          <Col xs={12} md={8} className="d-flex justify-content-center mb-4 mb-md-0">
            <div style={{ width: '100%', maxWidth: '220px', position: 'relative' }}>
              <ResponsiveContainer width="100%" height={220}>
                <PieChart>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius="75%"
                    outerRadius="100%"
                    paddingAngle={1}
                    dataKey="value"
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Pie
                    data={[{ value: 100 }]}
                    cx="50%"
                    cy="50%"
                    innerRadius="58%"
                    outerRadius="76%"
                    fill="#E9EAEB"
                    dataKey="value"
                    isAnimationActive={false}
                  />
                </PieChart>
              </ResponsiveContainer>

              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center',
                  pointerEvents: 'none',
                }}
              >
                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0A0D12' }}>
                  {highestValue.value.toFixed(0)}%
                </div>
                <div style={{ fontSize: '14px', color: '#717680', textTransform: 'capitalize' }}>
                  {highestValue.name.replace('_', ' ')}
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={4}>
            <div className="follower-types-legends">
              {chartData.map((entry, index) => (
                <div key={index} className="my-1">
                  <div className="d-flex align-items-center mb-2">
                    <svg width="16" height="16">
                      <circle cx="8" cy="8" r="8" fill={COLORS[index % COLORS.length]} />
                    </svg>
                    <div className="ms-2 fw-bold">{entry.value}%</div>
                  </div>
                  <div className="text-muted" style={{ fontSize: '14px' }}>
                    {entry.name}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FollowerTypes;